




















import {Component, Emit, Inject, Prop} from "vue-property-decorator";
import CommonBase from "../CommonBase";
import Api from "./Api";

@Component
export default class TerminalDescriptionEdit extends CommonBase {
    @Inject()
    api!: Api;

    @Prop()
    terminalGuid!: string;

    @Prop()
    description!: string;

    @Prop()
    value!: boolean;

    descr = this.description;
    saving = false;

    async save() {
        this.saving = true;
        try {
            await this.api.terminalDescriptionSave(this.terminalGuid, this.descr);
            this.$emit("at-terminal-description-changed", this.descr);
            this.show = false;
        } catch(err) {
            this.emitError(err);
        } finally {
            this.saving = false;
        }
    }
    close() {
        this.show = false;
    }

    get show() {
        return this.value;
    }
    set show(v: boolean) {
        this.$emit("input", v);
    }
}
